import React from 'react';
import styles from './style.module.scss';

interface Props {
  value: string;
  label: string;
}

export default function Statistic({ value, label }: Props) {
  return (
    <div className={styles.stat}>
      <div className={styles['stat-number']}>
        {value}
      </div>
      <div className={styles['stat-description']}>
        {label}
      </div>
    </div>
  );
}
